import React, { useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import CouponTimePicker from "./component";
import { useNavigate } from "react-router-dom";
import {
  onChange_CouponDescription_Step2,
  onChange_CouponImage_Step3,
  onChange_CouponDate_Step4,
  onChange_CouponDeeplink_Step5,
} from "../CouponCreate/action";
import { toast } from "react-toastify";
import "./component.css";

const CouponTimeSlot = (props) => {
  console.log("CouponDesContainer props", props);

  const [deeplink, setDeeplink] = useState("");
  const [timePairs, setTimePairs] = useState([
    { start: "00", end: "01" },
  ]);
  const [finalData, setFinalData] = useState(null);
  const [active, setActive] = useState("yes");

  const navigate = useNavigate();

  // Create initial 24-hour slot object
  const buildInitialSlotState = (isTimeSlot) => ({
    isTimeSlot: isTimeSlot,
    ...Array.from({ length: 24 }, (_, i) => {
      const start = String(i).padStart(2, "0");
      const end = String((i + 1) % 24).padStart(2, "0");

      return {
        [`${start}-${end}`]: null,
      };
    }).reduce((acc, curr) => ({ ...acc, ...curr }), {}),
  });

  const hours = Array.from({ length: 24 }, (_, i) =>
    String(i).padStart(2, "0")
  );

  // Update start/end time pair
  const updatePair = (index, field, value) => {
    const updated = [...timePairs];

    updated[index][field] = value;

    // Automatically set end time when start time changes
    if (field === "start") {
      const autoEnd = String(
        (parseInt(value, 10) + 1) % 24
      ).padStart(2, "0");

      updated[index].end = autoEnd;
    }

    setTimePairs(updated);
  };

  // Add new time pair
  const addPair = () => {
    setTimePairs([
      ...timePairs,
      {
        start: "00",
        end: "01",
      },
    ]);
  };

  // Remove time pair
  const removePair = (index) => {
    const updated = [...timePairs];

    updated.splice(index, 1);

    setTimePairs(updated);
  };

  /**
   * Build couponTimeSlot object
   *
   * Required payload:
   *
   * couponTimeSlot: {
   *   isTimeSlot: true,
   *   "00-01": null,
   *   "01-02": true,
   *   "02-03": null,
   *   ...
   * }
   */
  const buildFinalObject = (isTimeSlot) => {
    const base = buildInitialSlotState(isTimeSlot);

    timePairs.forEach(({ start, end }) => {
      const key = `${start}-${end}`;

      if (Object.prototype.hasOwnProperty.call(base, key)) {
        base[key] = true;
      }
    });

    return base;
  };

  // Step 5 - Save coupon deeplink
  const couponCreationStep5 = () => {
    console.log(
      "draftId:",
      localStorage.getItem("draftId")
    );

    if (deeplink === "") {
      toastr.warning("Enter Coupon Deeplink");
      return;
    }

    props.getDataFromAPI(
      `/partner/api/v1/coupon/create/draft`,
      "POST",
      {
        step: 21,
        draftId:
          props.props &&
          props.props.coupon &&
          props.props.coupon.step1_draftId,
        deeplink: deeplink,
      },
      (response) => {
        console.log("API response step 5:", response);

        setDeeplink(deeplink);

        props.onChange_CouponDescription_Step2(response);
        props.onChange_CouponImage_Step3(response);
        props.onChange_CouponDate_Step4(response);
        props.onChange_CouponDeeplink_Step5(response);

        navigate("/home/coupondiscountamount");
      },
      (err) => {
        toastr.error(
          "Error",
          "Failed to create coupon."
        );
      },
      true
    );
  };

  // Step 6 - Save coupon time slot
  const couponCreationStep6 = (e, isTimeSlot) => {
    /**
     * isTimeSlot should be inside couponTimeSlot
     */
    const timeSlotEnabled =
      active === "yes";

    const fullPayload = {
      step: 21,
      draftId:
        props.props &&
        props.props.coupon &&
        props.props.coupon.step1_draftId,

      couponTimeSlot: buildFinalObject(timeSlotEnabled),
    };

    console.log(
      "Coupon Time Slot Payload:",
      fullPayload
    );

    props.getDataFromAPI(
      `/partner/api/v1/coupon/create/draft`,
      "POST",
      fullPayload,
      (response) => {
        console.log(
          "API response step 6:",
          response
        );

        // Update Redux state
        props.onChange_CouponDescription_Step2(
          response
        );

        props.onChange_CouponImage_Step3(
          response
        );

        props.onChange_CouponDate_Step4(
          response
        );

        // Navigate to deeplink screen
        navigate("/home/coupondeeplink");
      },
      (err) => {
        toastr.error(
          err && err.message
            ? err.message
            : "Failed to save coupon time slot.",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          }
        );
      },
      true
    );
  };

  return (
    <>
      <CouponTimePicker
        addPair={addPair}
        active={active}
        setActive={setActive}
        updatePair={updatePair}
        hours={hours}
        setFinalData={setFinalData}
        setTimePairs={setTimePairs}
        couponCreationStep6={couponCreationStep6}
        timePairs={timePairs}
        removePair={removePair}
      />
    </>
  );
};

function mapStateToProps(props) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
  onChange_CouponDescription_Step2,
  onChange_CouponImage_Step3,
  onChange_CouponDate_Step4,
  onChange_CouponDeeplink_Step5,
})(CouponTimeSlot);